import React, { useEffect } from "react";
import { colors } from "../../config/color";
import Loader from "../loader";

export type ResultProps = {
  to: string;
  type?: keyof typeof colors;
};

export const Result: React.FC<ResultProps> = ({ to, type }) => {
  useEffect(() => {
    if (to !== undefined) {
      window.location.replace(process.env.REACT_APP_ORIGIN + to);
    }
  }, [to]);

  return (
    <div className="shindan-app__result">
      <Loader color={type && colors[type]} />
      <p>診断結果を表示します。</p>
    </div>
  );
};
